var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "input-ui",
      class: [
        _vm.size ? "input-ui--" + _vm.size : "",
        {
          "input-ui--focus": _vm.isFocus && !_vm.disabled && !_vm.noEdit,
          disabled: _vm.disabled,
          completed: _vm.completed,
          "input-ui--no-edit": _vm.noEdit,
          "input-ui--show-clear": _vm.showBtnClear,
          "input-ui--no-label": !_vm.placeholder
        },
        _vm.externalClass
      ]
    },
    [
      _vm._t("before"),
      _vm._v(" "),
      _c("label", [
        _vm.placeholder
          ? _c("span", { attrs: { hidden: "" } }, [
              _vm._v("\n      " + _vm._s(_vm.placeholder) + "\n    ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "input",
          _vm._b(
            {
              ref: "input",
              staticClass: "input-ui__input",
              attrs: {
                type: _vm.type,
                disabled: _vm.disabled || _vm.noEdit,
                maxlength: _vm.maxLength,
                placeholder: _vm.isFocus ? _vm.placeholderInput : ""
              },
              domProps: { value: _vm.value },
              on: {
                input: function($event) {
                  return _vm.onInput($event.target.value)
                },
                blur: _vm.onBlur,
                focus: _vm.onFocus,
                change: function($event) {
                  return _vm.onChange($event.target.value)
                }
              }
            },
            "input",
            _vm.params,
            false
          )
        )
      ]),
      _vm._v(" "),
      _vm.placeholder
        ? _c(
            "span",
            {
              staticClass: "input-ui__label",
              class: { small: _vm.isFocus || _vm.value || _vm.value === 0 },
              on: { click: _vm.setInputFocus }
            },
            [_vm._v("\n    " + _vm._s(_vm.placeholder) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("after"),
      _vm._v(" "),
      _vm.showBtnClear
        ? _c(
            "button",
            {
              staticClass: "input-ui__clear",
              attrs: { type: "button", tabindex: "-1" },
              on: { click: _vm.clearInput }
            },
            [
              _c("Icon", {
                staticClass: "input-ui__clear-icon",
                attrs: { icon: "r-close-window-rounded" }
              })
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }